import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export const SpecialOfferWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: stretch;

    padding: 16px 24px 24px 24px;

    background: url('/static/images/full-buy/rouble-bg-mobile.svg') no-repeat ${COLORS.Locked};
    
    @media (min-width: ${wideBreakpoints.mobile}) {
        flex-wrap: nowrap;
        flex-direction: row;
        align-items: flex-start;

        padding: 16px 32px 24px 32px;
        background-image: url('/static/images/full-buy/rouble-bg.svg');
    }
`;
